import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MonoCard from "@/components/common/MonoCard.vue";
import FlexRow from "@/components/common/FlexRow.vue";
import FlexCol from "@/components/common/FlexCol.vue";

import { ref } from "vue";
import {AuthService} from "@/service/auth-service";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {


let data = ref({
  username: "",
  password: ""
});


let service = new AuthService();

function submit() {
  service.login(data.value);
}


return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(FlexRow, { class: "h-[100vh] bg-chrome-bg justify-center items-center" }, {
    default: _withCtx(() => [
      _createVNode(FlexCol, null, {
        default: _withCtx(() => [
          _createVNode(MonoCard, { class: "bg-teal-800" }, {
            default: _withCtx(() => [
              _createVNode(FlexCol, { class: "gap-3" }, {
                default: _withCtx(() => [
                  _createVNode(FlexRow, null, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("h1", { class: "text-white text-2xl text-center w-full" }, " Login ", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(FlexRow, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_input, {
                        color: "teal-7",
                        "bg-color": "white",
                        "label-color": "teal-7",
                        type: "text",
                        outlined: "",
                        dense: "",
                        rounded: "",
                        modelValue: _unref(data).username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).username) = $event)),
                        label: "Login"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(FlexRow, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_input, {
                        color: "teal-7",
                        "bg-color": "white",
                        "label-color": "teal-7",
                        type: "password",
                        outlined: "",
                        dense: "",
                        rounded: "",
                        modelValue: _unref(data).password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).password) = $event)),
                        label: "Password"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(FlexRow, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        flat: "",
                        rounded: "",
                        class: "bg-mg-900 capitalize w-full",
                        color: "white",
                        onClick: submit,
                        label: "submit"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})